export default {
  'pages.layouts.userLayout.title': '',
  'pages.login.accountLogin.tab': 'Đăng nhập tài khoản',
  'pages.login.accountLogin.errorMessage': 'Tên đăng nhập/mật khẩu không đúng',
  'pages.login.failure': 'Đăng nhập thất bại, vui lòng thử lại!',
  'pages.login.success': 'Đăng nhập thành công!',
  'pages.login.username.placeholder': 'Tên đăng nhập',
  'pages.login.username.required': 'Vui lòng nhập tên đăng nhập!',
  'pages.login.password.placeholder': 'Mật khẩu',
  'pages.login.password.required': 'Vui lòng nhập mật khẩu!',
  'pages.login.phoneLogin.tab': 'Đăng nhập điện thoại',
  'pages.login.phoneLogin.errorMessage': 'Lỗi mã xác minh',
  'pages.login.phoneNumber.placeholder': 'Số điện thoại',
  'pages.login.phoneNumber.required': 'Vui lòng nhập số điện thoại!',
  'pages.login.phoneNumber.invalid': 'Số điện thoại không hợp lệ!',
  'pages.login.captcha.placeholder': 'Mã xác minh',
  'pages.login.captcha.required': 'Vui lòng nhập mã xác minh!',
  'pages.login.phoneLogin.getVerificationCode': 'Lấy mã',
  'pages.getCaptchaSecondText': 'giây',
  'pages.login.rememberMe': 'Ghi nhớ đăng nhập',
  'pages.login.forgotPassword': 'Quên mật khẩu?',
  'pages.login.submit': 'Đăng nhập',
  'pages.login.loginWith': '',
  'pages.login.registerAccount': 'Đăng ký tài khoản',
  'pages.welcome.link': 'Chào mừng',
  'pages.welcome.alertMessage':
    'Các thành phần mạnh mẽ và nhanh hơn đã được phát hành.',
  'pages.404.subTitle': 'Xin lỗi, trang bạn truy cập không tồn tại.',
  'pages.404.buttonText': 'Về trang chủ',
  'pages.admin.subPage.title': 'Trang này chỉ có thể được xem bởi Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui hiện đã được phát hành, chào mừng sử dụng npm run ui để bắt đầu trải nghiệm.',
  'pages.searchTable.createForm.newRule': 'Quy tắc mới',
  'pages.searchTable.updateForm.ruleConfig': 'Cấu hình quy tắc',
  'pages.searchTable.updateForm.basicConfig': 'Thông tin cơ bản',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Tên quy tắc',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Vui lòng nhập tên quy tắc!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Mô tả quy tắc',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Vui lòng nhập ít nhất năm ký tự',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Vui lòng nhập mô tả quy tắc ít nhất năm ký tự!',
  'pages.searchTable.updateForm.ruleProps.title': 'Cấu hình thuộc tính',
  'pages.searchTable.updateForm.object': 'Đối tượng giám sát',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Mẫu quy tắc',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Loại quy tắc',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Đặt chu kỳ lập lịch',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Thời gian bắt đầu',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Vui lòng chọn thời gian bắt đầu!',
  'pages.searchTable.titleDesc': 'Mô tả',
  'pages.searchTable.ruleName': 'Tên quy tắc là bắt buộc',
  'pages.searchTable.titleCallNo': 'Số lần gọi dịch vụ',
  'pages.searchTable.titleStatus': 'Trạng thái',
  'pages.searchTable.nameStatus.default': 'mặc định',
  'pages.searchTable.nameStatus.running': 'đang chạy',
  'pages.searchTable.nameStatus.online': 'trực tuyến',
  'pages.searchTable.nameStatus.abnormal': 'bất thường',
  'pages.searchTable.titleUpdatedAt': 'Lập lịch lần cuối tại',
  'pages.searchTable.exception': 'Vui lòng nhập lý do ngoại lệ!',
  'pages.searchTable.titleOption': 'Tùy chọn',
  'pages.searchTable.config': 'Cấu hình',
  'pages.searchTable.subscribeAlert': 'Đăng ký cảnh báo',
  'pages.searchTable.title': 'Biểu mẫu truy vấn',
  'pages.searchTable.new': 'Mới',
  'pages.searchTable.chosen': 'đã chọn',
  'pages.searchTable.item': 'mục',
  'pages.searchTable.totalServiceCalls': 'Tổng số lần gọi dịch vụ',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'xóa hàng loạt',
  'pages.searchTable.batchApproval': 'phê duyệt hàng loạt',
  // Premium COW Admin
  'pages.welcome.title': 'Chào mừng đến với COW Admin System',
  'pages.welcome.description': 'Hệ thống quản trị chuyên sâu dành cho dự án COW WALLET. Tại đây, bạn có thể giám sát hoạt động đào COW, quản lý thợ đào, và theo dõi các giao dịch hệ thống một cách minh bạch và hiệu quả nhất. Giao diện được thiết kế theo tiêu chuẩn Premium với trải nghiệm mượt mà.',
  'pages.welcome.card.mining.title': 'Giám sát Đào COW',
  'pages.welcome.card.mining.desc': 'Theo dõi các chỉ số thời gian thực về tổng lượng COW đào được, tỷ lệ thành công và số lượng thợ đào đang online.',
  'pages.welcome.card.miner.title': 'Quản lý Thợ đào',
  'pages.welcome.card.miner.desc': 'Xem thông tin chi tiết từng ví, trạng thái liên kết mạng xã hội và lịch sử khai thác COW của người dùng.',
  'pages.welcome.card.activity.title': 'Khám phá Hoạt động',
  'pages.welcome.card.activity.desc': 'Tra cứu nhật ký hoạt động hệ thống bao gồm log chuyển khoản, thăng cấp và liên kết tài khoản.',
  'pages.login.subTitle': 'Hệ thống Quản trị Khai thác COW',
  'request.error.dataFailed': 'Yêu cầu dữ liệu thất bại!',
  'request.error.noResponse': 'Không nhận được phản hồi từ máy chủ! Vui lòng thử lại.',
  'request.error.setupError': 'Lỗi yêu cầu, vui lòng thử lại sau.',
  'request.error.responseStatus': 'Mã lỗi phản hồi: ',
  // Dashboard Analysis Premium
  'dashboard.analysis.totalWallets': 'Tổng số ví',
  'dashboard.analysis.totalWalletsTooltip': 'Tổng số ví đã tạo trong hệ thống',
  'dashboard.analysis.todayWallets': 'Tổng số ví tạo trong ngày hôm nay',
  'dashboard.analysis.telegramVerifyRate': 'Tỷ lệ verify Telegram',
  'dashboard.analysis.telegramVerifyTooltip': 'Tổng số ví có liên kết với Telegram',
  'dashboard.analysis.walletCount': 'Số ví',
  'dashboard.analysis.telegramVerifyCount': 'Số verify Telegram',
  'dashboard.analysis.referralRanking': 'Xếp hạng Referral',
  'dashboard.analysis.noData': 'Không có dữ liệu',
  'dashboard.analysis.pendingApprovals': 'Yêu cầu chờ duyệt',
  'dashboard.analysis.pendingApprovalsTooltip': 'Số lượng giao dịch từ ví bị hạn chế đang chờ admin phê duyệt',
  'dashboard.analysis.viewAllApprovals': 'Xem tất cả yêu cầu',
  'dashboard.analysis.needsAttention': 'Cần xử lý ngay',
  'dashboard.analysis.noPending': 'Không có yêu cầu chờ',
};
